/* eslint-disable react/jsx-pascal-case */

/* Original name @uswitch/trustyle.hero-card */
import * as React from 'react';
import { Themed } from 'theme-ui';
import { ButtonLink } from '../../elements/button-link';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var styles = function styles(element) {
  return "compounds.heroCard.variants".concat(element ? ".".concat(element) : '');
};

var HeroCard = function HeroCard(_ref) {
  var title = _ref.title,
      ctaText = _ref.ctaText,
      ctaLink = _ref.ctaLink,
      children = _ref.children,
      bgImage = _ref.bgImage,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type;
  return _jsxs("div", {
    sx: {
      display: 'flex',
      variant: styles(type === 'seasonal' ? 'seasonal' : '')
    },
    children: [_jsxs("div", {
      sx: {
        variant: styles('flexContainer')
      },
      children: [_jsx(Themed.h1, {
        as: "h2",
        children: title
      }), type === 'seasonal' ? _jsx("div", {
        sx: {
          variant: styles('links.seasonal')
        },
        children: children
      }) : null, ctaText ? _jsx(ButtonLink, {
        variant: "primary",
        href: ctaLink,
        size: children && type === 'seasonal' ? 'fullWidth' : 'small',
        sx: {
          variant: styles('buttonLink'),
          display: ['none', 'initial']
        },
        children: ctaText
      }) : null]
    }), type === 'default' ? _jsx("div", {
      sx: {
        variant: styles('links')
      },
      children: children
    }) : null, ctaText ? _jsx(ButtonLink, {
      variant: "primary",
      href: ctaLink,
      size: children && type === 'seasonal' ? 'fullWidth' : 'small',
      sx: {
        variant: styles('buttonLink'),
        display: ['initial', 'none']
      },
      children: ctaText
    }) : null, bgImage ? _jsx("div", {
      sx: {
        display: ['none', 'none', 'block'],
        background: "url(".concat(bgImage, ") no-repeat right center / contain"),
        width: '404px',
        height: '416px'
      }
    }) : null]
  });
};

export default HeroCard;
//# sourceMappingURL=hero-card.js.map